import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Pagination } from '../../../models/pagination';
import { Serie } from '../../../models/serie';
import { ParametroService } from '../../../services/parametro.service';

@Component({
  selector: 'app-serie-detalle-modal',
  templateUrl: './serie-detalle-modal.component.html',
  styleUrls: ['./serie-detalle-modal.component.css'],
  providers: [ParametroService],
})
export class SerieDetalleModalComponent implements OnInit {
  @Input() series: Array<any>;
  public series_all: Array<any>;
  public nombre_codigo: string = "";
  public loading: boolean;
  public pagination: Pagination;
  constructor(
    public bsModalRef: BsModalRef,
    private parametroService: ParametroService,
  ) { 
    
  }

  ngOnInit() {
    this.loading = true;
    this.getNombeCodigo().then(
      res => this.loading = false,
      err => this.loading = false,
    );
    this.series_all = this.series;
  }

  getNombeCodigo(){
    return new Promise ((resolve, reject) => {
      this.parametroService.getById(31).subscribe(
        res => {
          this.nombre_codigo = res.valor;
          resolve(true);
        },
        err => {
          reject();
        }
      )
    });
  }

  getCodigoBySearch(text){
    this.series_all = this.series.filter(x => {
      if(x.serie.codigo.toLowerCase().includes(text.toLowerCase()) || x.serie.codigo.toLowerCase().includes(text.toLowerCase())) return x;
    });
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/serie-detalle-modal/serie-detalle-modal.component.ts